import { DropTable } from './DropTable';
export default DropTable;
